// src/data/gyms/Rogue.js
export const Rogue = {
  id: "rogue",
  name: "Rogue Athletics",
  color: "#DC2626", // Bold Red
  lightColor: "#FEF2F2",
  logo: "🟥",

  teams: [
    {
      id: "rage",
      name: "Rage",
      level: "L2.2 Senior - PREP",
    },
    {
      id: "reckless",
      name: "Reckless",
      level: "L1 Tiny - Novice",
    },
    {
      id: "riot",
      name: "Riot",
      level: "L1.1 Youth - PREP",
    },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "8:21 AM", // Floor compete
      teamId: "rage",
      meet: "7:45 AM", // Check-in
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "9:45 AM",
      teamId: "reckless",
      meet: "9:09 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "9:48 AM",
      teamId: "riot",
      meet: "9:12 AM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // No Sunday performances (One-day Prep/Novice competition).
  ],
};
